module.exports = __webpack_public_path__ + "4ae6fa049141dc143e805f6681030dab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003BT9.png
// module id = 1523
// module chunks = 0